import React from 'react';
import { Drawer, Button, Alert, Spin, Typography } from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FormDrawer = ({ 
  title, icon, open, onClose, onSave, loading, saving, children, width = 520, 
  error
}) => {
  
  return (
    <Drawer
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {icon && <span style={{ fontSize: 20 }}>{icon}</span>}
          <span>{title}</span>
        </div>
      }
      width={window.innerWidth < 600 ? '100%' : width}
      onClose={onClose}
      open={open}
      styles={{
        header: { borderBottom: '1px solid #e2e8f0', padding: '16px 24px' },
        body: { padding: 0, position: 'relative' }
      }}
      footer={
        <div style={{
          position: 'sticky',
          bottom: 0,
          background: '#fff',
          padding: '16px 24px',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Button icon={<CloseOutlined />} onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Text style={{ fontSize: 12, color: '#94a3b8' }}>
            Ctrl+S to save • Escape to cancel
          </Text>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={onSave}
            loading={saving}
            style={{
              background: 'linear-gradient(135deg, #1a56db 0%, #1e429f 100%)',
              border: 'none'
            }}
          >
            Save
          </Button>
        </div>
      }
    >
      <div style={{ padding: 24, overflowY: 'auto', maxHeight: 'calc(100vh - 180px)' }}>
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            style={{ marginBottom: 20 }}
          />
        )}
        {children}
      </div>

      {/* Loading Overlay */}
      {saving && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(255,255,255,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10
        }}>
          <Spin size="large" />
        </div>
      )}
    </Drawer>
  );
};

export default FormDrawer;